import { defaultProps } from '@blocknote/core';
import { createReactBlockSpec } from '@blocknote/react';
import './EditorTitleBlock.scss';

export const titleBlock = createReactBlockSpec(
  {
    type: 'titleBlock',
    propSchema: {
      textAlignment: defaultProps.textAlignment,
      textColor: defaultProps.textColor
    },
    content: 'inline'
  },
  {
    render: (props: any) => {
      const hasContent = props.block.content && props.block.content.length > 0;

      return (
        <div
          className="title-block-container relative mb-6 w-full max-w-3xl text-3xl font-bold leading-normal focus:outline-none"
          ref={props.contentRef}
          data-placeholder={!hasContent ? 'Untitled' : undefined}
        />
      );
    }
  }
);
